import type CalendarActionResponse from 'owa-service/lib/contract/CalendarActionResponse';

/**
 * Method to handle errors from calls to the owa service for actions that return CalendarActionResponses. Does not automatically handle undoing
 * any store updates made during the undoableAction- if store updates are made, the onServiceFailed callback needs to handle resetting those
 * properties.
 * @param undoableAction A callback function that issues the service request. If this request fails, onServicedFailed will be called
 * @param onServiceFailed A callback function fired if the undoableAction fails
 */
export default function handleCalendarServiceError<T extends CalendarActionResponse>(
    undoableAction: () => Promise<T>,
    onServiceFailed: () => void
): Promise<void> {
    return undoableAction()
        .then(response => {
            let result = successEvaluator(response);
            if (!result.isSuccessful && onServiceFailed) {
                onServiceFailed();
            }
        })
        .catch(error => {
            if (onServiceFailed) {
                onServiceFailed();
            }
        });
}

function successEvaluator(response: CalendarActionResponse) {
    let success = response.WasSuccessful;

    return {
        isSuccessful: success,
        error: success ? null : response.ErrorCode,
    };
}
